import React from "react";
import { Popup as Modal } from "reactjs-popup";
import { FilterModal } from "./ServiceRequestFilterModal/FilterModal";


export const FilterOverlay = ({
  showFilterOverlay,
  setShowFilterOverlay,
}) => {
  return (
    <>
      <Modal
        open={showFilterOverlay}
        onClose={() => setShowFilterOverlay(false)}
        closeOnDocumentClick={false}
        className="popup-content"
      >
        <FilterModal
          onClose={() => setShowFilterOverlay(false)}
        />
      </Modal>

      
    </>
  );
};
